import React, { useEffect, useState } from 'react';
import { apiCall } from '../utils/apiService';

/** Same base the app uses for requests (`apiService`), so docs match the current deployment. */
function getApiDisplayBase() {
  const raw = process.env.REACT_APP_API_URL;
  if (raw != null && String(raw).trim() !== '') {
    return String(raw).trim().replace(/\/+$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin.replace(/\/+$/, '')}/api`;
  }
  return '/api';
}

const APIAccessLayer = () => {
  const apiBase = getApiDisplayBase();
  const [apiKey, setApiKey] = useState('');

  const fetchAPIToken = async () => {
    try {
      const response = await apiCall({
        url: `user/get-user-by-token`,
        method: 'GET',
      });
      if (response) {
        setApiKey(response.data.api)
      }
    } catch (error) {
      console.error('Error fetching dashboard:', error);
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await apiCall({
        url: `user/generate-API`,
        method: 'GET',
      });

      if (response.success) {
        localStorage.setItem('apiKey', response.token);
        setApiKey(response.token)
      }

    } catch (error) {
      console.error('Error generating API key:', error);
    }
  };

  useEffect(() => {
    document.title = "API Access"
    fetchAPIToken();
  }, [])
  return (
    <>
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            Api Access
          </div>
        </div>
        <div className="card-body">
          <div className='py-3'>
            <p className='my-3 font-monospace small'>{apiKey}</p>
            <button type="button" onClick={handleSubmit} className='btn btn-success w-100'>
              GENERATE KEYS
            </button>
          </div>

          <hr className='my-5' />

          <section className="mb-32">
            <h5 className="mb-16">WhatsApp — send message (GET)</h5>
            <p className="text-secondary-light text-sm mb-16">
              Sends a text through your linked WhatsApp instance. Use your API key as <code className="text-xs">token</code> and your instance id as <code className="text-xs">client_id</code>.
            </p>
            <div className='bg-success-600 p-3 rounded'>
              <p className='text-white mb-0 text-break small' style={{ wordBreak: 'break-all' }}>
                {apiBase}/send-message/chat?to=YOUR_NUMBER&amp;text=YOUR_MESSAGE&amp;token=YOUR_API_KEY&amp;client_id=YOUR_CLIENT_ID
              </p>
            </div>
            <ul className="mt-16 text-sm text-secondary-light mb-0 ps-20">
              <li><code>to</code> — recipient (number or group id as required by WhatsApp)</li>
              <li><code>text</code> — message body</li>
              <li><code>token</code> — your API key (same as above)</li>
              <li><code>client_id</code> — WhatsApp instance client id</li>
            </ul>
          </section>

          <hr className='my-5' />

          <section>
            <h5 className="mb-16">SMS — send to phone number (GET)</h5>
            <p className="text-secondary-light text-sm mb-16">
              Sends an SMS by forwarding to the gateway URLs you saved under <strong>Devices</strong>. Omit <code className="text-xs">deviceId</code> to rotate across active devices (least recently used). Add <code className="text-xs">deviceId</code> (numeric id from the Devices list) to always use that gateway. The server POSTs JSON <code className="text-xs">to</code> / <code className="text-xs">text</code> to the gateway URL.
            </p>
            <div className='bg-primary-600 p-3 rounded'>
              <p className='text-white mb-0 text-break small' style={{ wordBreak: 'break-all' }}>
                {apiBase}/send-message/sms?to=YOUR_PHONE_NUMBER&amp;text=YOUR_MESSAGE&amp;token=YOUR_API_KEY
              </p>
              <p className='text-white mb-0 text-break small mt-12' style={{ wordBreak: 'break-all' }}>
                {apiBase}/send-message/sms?to=YOUR_PHONE_NUMBER&amp;text=YOUR_MESSAGE&amp;token=YOUR_API_KEY&amp;deviceId=YOUR_DEVICE_ID
              </p>
            </div>
            <ul className="mt-16 text-sm text-secondary-light mb-0 ps-20">
              <li><code>to</code> — destination phone number (format your gateway expects)</li>
              <li><code>text</code> — SMS body</li>
              <li><code>token</code> — your API key</li>
              <li><code>deviceId</code> — optional; numeric device id from <strong>Devices</strong> to target one gateway</li>
            </ul>
          </section>
        </div>
      </div>
    </>


  )
}

export default APIAccessLayer
